export default __webpack_public_path__ + "static/media/dog.50fdca09.svg";